import styled from 'styled-components';

import { ensurePxUnit } from '../../utils/mobileUtils';

export const StyledUnorderedList = styled.ul`
  margin: 0;
  padding-left: 34px;
  /* Apply dynamic font styles */
  font-family: ${({ styleProps }) => styleProps?.fontFamily};
  font-size: ${({ styleProps }) => ensurePxUnit(styleProps?.fontSize)};
  text-align: ${({ styleProps }) => styleProps?.textAlign};
  font-weight: ${({ styleProps }) => styleProps?.fontWeight};
  font-style: ${({ styleProps }) => styleProps?.fontStyle};
  color: ${({ styleProps }) => styleProps?.color};
`;